import { jsx as _jsx } from "react/jsx-runtime";
import styled from "styled-components";
import starterIcon from '../../../../public/img/start-icon.svg';
const Image = styled.img `
  position: absolute;
  top: -34px;
  left: calc(50% - 15px);

  border-radius: 50%;
  box-shadow: 0px 4px 3.9px 0px rgba(0, 0, 0, 0.46);
`;
export const StarterIcon = () => {
    Image.defaultProps = {
        src: starterIcon
    };
    return (_jsx(Image, {}));
};
